import {useState} from 'react';

import LogsModal from './components/LogsModal';
import LogsTab from './components/LogsTab/LogsTab';
import SegmentsPanel from './components/SettingsTab/SegmentsPanel';
import SettingsTab from './components/SettingsTab/SettingsTab';
import TabBar from './components/TabBar';
import VersionBadge from './components/VersionBadge';
import {TABS} from './consts/logsTabs';

const Logs = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [activeTab, setActiveTab] = useState(TABS.LOGS);
    const [isSegmentsOpen, setIsSegmentsOpen] = useState(false);

    const handleToggle = () => setIsVisible((prev) => !prev);

    return (
        <>
            {isSegmentsOpen && <SegmentsPanel onClose={() => setIsSegmentsOpen(false)} />}
            <VersionBadge onClick={handleToggle} />
            {isVisible && (
                <LogsModal onClose={handleToggle}>
                    <TabBar activeTab={activeTab} onTabChange={setActiveTab} />
                    {activeTab === TABS.LOGS && <LogsTab />}
                    {activeTab === TABS.SETTINGS && (
                        <SettingsTab onOpenSegments={() => setIsSegmentsOpen(true)} onClose={handleToggle} />
                    )}
                </LogsModal>
            )}
        </>
    );
};

export default Logs;
